// favorites.js
var DKT = DKT || {};
DKT.favorites = function($, DKTPaths, actualLanguage, existeGoogleAnalytics) {
  var isFavoritesPage = false;

  function init() {
    if (!isFavoritesPage) {
      subscribeFavoritesListeners();
      initializeTamborzones();
    }
  }

  function initFavoritesPage() {
    isFavoritesPage = true;
    var favorites = getFavorites();
    if (favorites.length < 1) {
      console.log("Cuando marques alguna tamborrada como favorita, aparecerá aquí");
      showNoResults();
      return;
    } else {
      callGetFavorites(favorites, actualLanguage);
    }
  }

  function callGetFavorites(favorites, actualLanguage) {
    showLoading();
    $.ajax({
      method: "POST",
      url: "/datosJSON/getFavorites.php",
      data: {
        favorites: favorites,
        actualLanguage: actualLanguage
      },
      success: onSuccess,
      error: onError,
      dataType: "json",
      timeout: 10000,
      cache: false
    });
  }

  function onSuccess(data) {
    if (data.length && data.length > 0) {
      data.sort(function(a, b) {
        return a.startTime < b.startTime ? -1 : 1;
      });
      data.forEach(item => {
        var parent = document.createElement("div");
        parent.classList.add("item");

        var row = document.createElement("div");

        var logoRow = document.createElement("div");
        logoRow.classList.add("logo");

        var logoItem = document.createElement("div");
        logoItem.classList.add("pull-left");
        logoItem.classList.add("item-image");

        var logoAnchor = document.createElement("a");
        logoAnchor.href = item.articleUrl;

        var logoImage = document.createElement("img");
        logoImage.src = item.logoUrl;
        logoImage.setAttribute("itemprop", "thumbnailUrl");

        logoAnchor.appendChild(logoImage);
        logoItem.appendChild(logoAnchor);
        logoRow.appendChild(logoItem);
        row.appendChild(logoRow);

        var infoBarrio = document.createElement("div");
        infoBarrio.classList.add("info-barrio");

        var row2 = document.createElement("div");

        var redesCorazon = document.createElement("div");
        redesCorazon.classList.add("redes-corazon");

        var imageBihotza = document.createElement("img");
        imageBihotza.classList.add("img-bihotza");
        imageBihotza.setAttribute("data-tamborrada-id", item.id);
        imageBihotza.src = "/templates/t3_bs3_blank/images/bihotza-off.png";

        var titleName = document.createElement("h3");

        var anchorTitle = document.createElement("a");
        anchorTitle.href = item.articleUrl;
        anchorTitle.innerHTML = item.name;
        anchorTitle.setAttribute("itemprop", "url");

        var horaSalida = document.createElement("p");
        horaSalida.classList.add("hora-salida");
        horaSalida.innerHTML = 'Hora de salida <span class="mini-flecha"></span> ' + item.startTime;

        var readMore = document.createElement("p");
        readMore.classList.add("readmore");

        var anchorReadMore = document.createElement("a");
        anchorReadMore.href = item.articleUrl;
        anchorReadMore.setAttribute("itemprop", "url");

        redesCorazon.appendChild(imageBihotza);
        titleName.appendChild(anchorTitle);
        readMore.appendChild(anchorReadMore);

        row2.appendChild(redesCorazon);
        row2.appendChild(titleName);
        row2.appendChild(horaSalida);
        row2.appendChild(readMore);
        infoBarrio.appendChild(row2);

        parent.appendChild(row);
        parent.appendChild(infoBarrio);

        var favoritesContainer = document.getElementsByClassName("favoritas-container")[0];
        if (favoritesContainer) {
          favoritesContainer.appendChild(parent);
        }
      });
      favoritesHaveBeenFetched();
      hideLoading();
    } else {
      console.log("No se han encontrado datos de tus favoritas.");
      showNoResults();
    }
  }

  function onError(error) {
    console.log(error);
    console.log("No se han podido recuperar datos de tus favoritas.");
    showError();
  }

  function showLoading() {
    $("#loading").css("display", "block");
  }

  function hideLoading() {
    $("#loading").css("display", "none");
  }

  function showNoResults() {
    var message = document.createElement("div");
    message.classList.add("alert");
    message.classList.add("alert-info");
    message.innerHTML = DKT.translations.noFavorites;

    var favoritesContainer = document.getElementsByClassName("favoritas-container")[0];
    if (favoritesContainer) {
      favoritesContainer.appendChild(message);
    }
    hideLoading();
  }

  function showError() {
    var message = document.createElement("div");
    message.classList.add("alert");
    message.classList.add("alert-danger");
    message.innerHTML = DKT.translations.errorGeneric;

    var favoritesContainer = document.getElementsByClassName("favoritas-container")[0];
    if (favoritesContainer) {
      favoritesContainer.appendChild(message);
    }
    hideLoading();
  }

  function favoritesHaveBeenFetched() {
    subscribeFavoritesListeners();
    initializeTamborzones();
  }

  function initializeTamborzones() {
    var tamborradaIds = $(".img-bihotza[data-tamborrada-id]")
      .map(function() {
        return this.dataset.tamborradaId;
      })
      .get();

    tamborradaIds.forEach(function(id) {
      if (isFavorite(id)) turnOnFavoriteButtons(id);
      else turnOffFavoriteButtons(id);
    });
  }

  function getFavorites() {
    if (localStorage.getItem("favoriteTamborradas")) {
      try {
        var favoriteTamborradas = JSON.parse(localStorage.getItem("favoriteTamborradas"));
      } catch (e) {
        console.log("No se ha podido convertir el JSON desde local storage");
        var favoriteTamborradas = [];
      }
      return favoriteTamborradas;
    }
    return [];
  }

  function addFavorite(id) {
    var favoriteTamborradas = getFavorites();
    var isAlreadyFavorite = isFavorite(id);
    if (!isAlreadyFavorite) {
      favoriteTamborradas.push(id);
    }

    var pairId = DKTPaths.getTamborradaPairId(id);
    if (pairId !== null) {
      var isAlreadyFavoritePair = isFavorite(pairId);
      if (!isAlreadyFavoritePair) {
        favoriteTamborradas.push(pairId);
      }
    }
    localStorage.setItem("favoriteTamborradas", JSON.stringify(favoriteTamborradas));
    if (existeGoogleAnalytics) ga("gtm1.send", "event", "favoritos", "añadir favorito", window.location.href);
  }

  function isFavorite(id) {
    var favoriteTamborradas = getFavorites();
    var isAlreadyFavorite = false;
    for (var i = 0; i < favoriteTamborradas.length; i++) {
      var item = favoriteTamborradas[i];
      if (item == id) {
        isAlreadyFavorite = true;
        break;
      }
    }

    return isAlreadyFavorite;
  }

  function removeFavorite(id) {
    var favoriteTamborradas = getFavorites();
    var pairId = DKTPaths.getTamborradaPairId(id);
    var newFavorites = favoriteTamborradas.filter(function(item) {
      return item != id && item != pairId;
    });
    localStorage.setItem("favoriteTamborradas", JSON.stringify(newFavorites));
    if (existeGoogleAnalytics) ga("gtm1.send", "event", "favoritos", "quitar favorito", window.location.href);
  }

  function removeAllFavorites() {
    localStorage.setItem("favoriteTamborradas", JSON.stringify([]));
  }

  function subscribeFavoritesListeners() {
    $("#map").on("change", ".checkFav", handleFavToggle);
    $(".img-bihotza").on("click", handleFavToggleFromPage);
  }

  function handleFavToggle(e) {
    var isChecked = e.target.checked;
    var tamborradaId = e.target.dataset.tamborradaId;
    if (isChecked) {
      addFavorite(tamborradaId);
      $("#map").trigger("custom_toggleFav", [tamborradaId, "add"]);
      turnOnFavoriteButtons(tamborradaId);
    } else {
      removeFavorite(tamborradaId);
      $("#map").trigger("custom_toggleFav", [tamborradaId, "remove"]);
      turnOffFavoriteButtons(tamborradaId);
    }
  }

  function handleFavToggleFromPage(e) {
    var wasFavorite = e.target.dataset.isFavorite === "true" ? true : false;
    var tamborradaId = e.target.dataset.tamborradaId;

    if (tamborradaId) {
      if (!wasFavorite) {
        addFavorite(tamborradaId);
        $("#map").trigger("custom_toggleFav", [tamborradaId, "add"]);
        turnOnFavoriteButtons(tamborradaId);
      } else {
        removeFavorite(tamborradaId);
        $("#map").trigger("custom_toggleFav", [tamborradaId, "remove"]);
        turnOffFavoriteButtons(tamborradaId);
      }
    }
  }

  function turnOnFavoriteButtons(id) {
    $(".img-bihotza[data-tamborrada-id=" + id + "]").attr("src", "/templates/t3_bs3_blank/images/bihotza.png");
    $(".img-bihotza[data-tamborrada-id=" + id + "]").attr("data-is-favorite", true);
    $(".img-bihotza[data-tamborrada-id=" + id + "]").addClass("heartbeat");
    $(".leaflet-container label img[data-tamborrada-id=" + id + "]").attr(
      "src",
      "/templates/t3_bs3_blank/images/bihotza-positivo.png"
    );
    $("#img-big-bihotza").attr("src", "/templates/t3_bs3_blank/images/big-bihotza-on.png");
    $(".tamborrada-fav .txt-favorita").removeClass("hidden");
    $(".tamborrada-fav .anade-a-favoritas").addClass("hidden");
  }

  function turnOffFavoriteButtons(id) {
    $(".img-bihotza[data-tamborrada-id=" + id + "]").attr("src", "/templates/t3_bs3_blank/images/bihotza-off.png");
    $(".img-bihotza[data-tamborrada-id=" + id + "]").attr("data-is-favorite", false);
    $(".img-bihotza[data-tamborrada-id=" + id + "]").removeClass("heartbeat");
    $(".leaflet-container label img[data-tamborrada-id=" + id + "]").attr(
      "src",
      "/templates/t3_bs3_blank/images/bihotza-positivo-off.png"
    );
    $("#img-big-bihotza").attr("src", "/templates/t3_bs3_blank/images/big-bihotza-off.png");
    $(".tamborrada-fav .anade-a-favoritas").removeClass("hidden");
    $(".tamborrada-fav .txt-favorita").addClass("hidden");
  }

  return {
    init: init,
    initFavoritesPage: initFavoritesPage,
    getFavorites: getFavorites,
    addFavorite: addFavorite,
    isFavorite: isFavorite,
    removeFavorite: removeFavorite,
    removeAllFavorites: removeAllFavorites,
    turnOnFavoriteButtons: turnOnFavoriteButtons,
    turnOffFavoriteButtons: turnOffFavoriteButtons
  };
};
